import styled from 'styled-components';
import { Link } from 'react-router-dom'; // 추가
import React, { useState } from 'react';
import { FaBars, FaTimes } from 'react-icons/fa';

const Nav = styled.nav`
  background: white;
  border-bottom: 1px solid ${props => props.theme.colors.border};
  position: sticky;
  top: 0;
  z-index: 1000;
  padding: 0 20px;
`;

const NavInner = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 80px;
  max-width: 1200px;
  margin: 0 auto;
`;

const Dropdown = styled.ul`
  position: absolute;
  top: 36px;
  left: 50%;
  transform: translateX(-50%) translateY(-10px);
  background: white;
  min-width: 160px;
  border: 1px solid ${props => props.theme.colors.border};
  border-top: 3px solid ${props => props.theme.colors.primary};
  border-radius: 8px;
  list-style: none;
  padding: 10px 0;
  box-shadow: 0 20px 20px rgba(0,0,0,0.08);
  
  /* 애니메이션 설정 */
  visibility: hidden;
  opacity: 0;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  pointer-events: none;

  /* 그라데이션 포인트 추가 */
  &::before {
    content: '';
    position: absolute;
    top: -20px; /* 메뉴와 드롭다운 사이의 간격을 메워줌 */
    left: 0;
    width: 100%;
    height: 20px;
    background: transparent;
  }
`;

const NavItem = styled.li`
  position: relative;
  display: flex;
  align-items: center;
  height: 100%;
  font-weight: 600;
  padding: 0 5px;

  &:hover ${Dropdown} {
    visibility: visible;
    opacity: 1;
    transform: translateX(-50%) translateY(0); /* 원래 위치로 부드럽게 내려옴 */
    pointer-events: auto;
  }
`;

const DropdownItem = styled(Link)`
  display: block;
  padding: 12px 24px;
  text-decoration: none;
  color: ${props => props.theme.colors.textMain};
  font-size: 14px;
  transition: background 0.2s ease;

  &:hover {
    /* 호버 시 살짝 밝은 블루 계열 그라데이션 배경 적용 */
    background: linear-gradient(90deg, #f0f7ff 0%, #ffffff 100%);
    color: ${props => props.theme.colors.primary};
  }
`;

const Menu = styled.ul`
  display: flex;
  gap: 40px;

  @media (max-width: 768px) {
    display: none; /* 일단 모바일에서는 메뉴를 숨깁니다 (나중에 햄버거 버튼으로 구현) */
  }
`;

const StyledLink = styled(Link)`
  text-decoration: none;
  color: inherit;
  &:hover { color: ${props => props.theme.colors.primary}; }
`;

const LogoWrapper = styled(Link)`
  display: flex;
  align-items: center;
  text-decoration: none;
`;

const LogoImage = styled.img`
  height: 50px; /* 로고 크기에 맞춰 적절히 조절 */
  width: auto;
  object-fit: contain;
`;

const MobileIcon = styled.div`
  display: none;
  @media (max-width: 768px) {
    display: block;
    font-size: 1.8rem;
    cursor: pointer;
    z-index: 2000;
  }
`;

const MobileMenu = styled.div`
  display: none;
  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    position: fixed;
    top: 0;
    right: ${props => props.isOpen ? '0' : '-100%'}; /* 열림 상태에 따라 이동 */
    width: 70%;
    height: 100vh;
    background: white;
    padding-top: 100px;
    transition: 0.3s ease-in-out;
    box-shadow: -5px 0 15px rgba(0,0,0,0.1);
    z-index: 1500;
  }
`;

const MobileLink = styled(Link)`
  padding: 20px 40px;
  font-size: 1.2rem;
  font-weight: 600;
  text-decoration: none;
  color: ${props => props.theme.colors.textMain};
  border-bottom: 1px solid #eee;
  
  &:hover { color: ${props => props.theme.colors.primary}; }
`;

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const toggleMenu = () => setIsOpen(!isOpen);

  return (
    <Nav>
      <NavInner>
      <LogoWrapper to="/">
        <LogoImage src="/images/logo_doosungsystem.png" alt="두성시스템" />
      </LogoWrapper>
      <Menu>
        <NavItem>
          <StyledLink to="/about">회사소개</StyledLink>
          <Dropdown>
            <li><DropdownItem to="/about">인사말</DropdownItem></li>
            <li><DropdownItem to="/about/history">연혁</DropdownItem></li>
            {/* 조직도 임시 숨김: 아래 줄 주석 해제 시 다시 노출 */}
            {/* <li><DropdownItem to="/about/organization">조직도</DropdownItem></li> */}
            <li><DropdownItem to="/about/location">오시는길</DropdownItem></li>
            <li><DropdownItem to="/about/certifications">보유인증현황</DropdownItem></li>
          </Dropdown>
        </NavItem>

        <NavItem>
          <StyledLink to="/business">사업영역</StyledLink>
          <Dropdown>
            <li><DropdownItem to="/business/interior">실내건축</DropdownItem></li>
            <li><DropdownItem to="/business/landscape">조경식재</DropdownItem></li>
            <li><DropdownItem to="/business/metal">금속구조물·지붕</DropdownItem></li>
            <li><DropdownItem to="/business/finishing">도장·방수·석공사</DropdownItem></li>
            <li><DropdownItem to="/business/pavement">지반조성·포장</DropdownItem></li>
            <li><DropdownItem to="/business/management">건물종합관리</DropdownItem></li>
            <li><DropdownItem to="/business/tank">물탱크청소</DropdownItem></li>
            <li><DropdownItem to="/business/disinfection">소독업</DropdownItem></li>
          </Dropdown>
        </NavItem>

        <NavItem>
          <StyledLink to="/promotion/social">홍보센터</StyledLink>
          <Dropdown>
            <li><DropdownItem to="/promotion/social">사회적기업</DropdownItem></li>
            <li><DropdownItem to="/promotion/women">여성기업</DropdownItem></li>
          </Dropdown>
        </NavItem>

        <NavItem>
          <StyledLink to="/notices">고객센터</StyledLink>
          <Dropdown>
            <li><DropdownItem to="/notices">공지사항</DropdownItem></li>
            <li><DropdownItem to="/inquiry">견적문의</DropdownItem></li>
          </Dropdown>
        </NavItem>
      </Menu>
      <MobileIcon onClick={toggleMenu}>
        {isOpen ? <FaTimes /> : <FaBars />}
      </MobileIcon>

      <MobileMenu isOpen={isOpen}>
        <MobileLink to="/about" onClick={toggleMenu}>회사소개</MobileLink>
        <MobileLink to="/business" onClick={toggleMenu}>사업영역</MobileLink>
        <MobileLink to="/promotion/social" onClick={toggleMenu}>홍보센터</MobileLink>
        <MobileLink to="/notices" onClick={toggleMenu}>고객센터</MobileLink>
      </MobileMenu>
      </NavInner>
    </Nav>
  );
};

export default Header;